export enum EGender {
  Male = 'M',
  Female = 'F',
  Other = 'O',
  Unknown = 'U',
}

export enum EGenderLabel {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
  Unknown = 'Unknown',
}
